<script setup lang="ts">
import { computed, h } from 'vue'
import type { RiskConfig, RiskShort } from '@/models/api-generated'
import { parseRiskScore, scoreToLevel } from '../shared'
import RisksTooltip from '../RisksTooltip.vue'

const props = defineProps<{
	class?: any
	config: RiskConfig
}>()

const model = defineModel<RiskShort[][][]>({ required: true })

const rows = computed(() =>
	Array(props.config.matrixSize)
		.fill(0)
		.map((_, index) => 1 + index)
		.reverse(),
)
const cols = computed(() => props.config.matrixSize)

function bg(x: number, y: number) {
	const score = parseRiskScore(x * y, props.config)
	const lvl = scoreToLevel(score, props.config)
	return 'background-color: ' + lvl?.color
}

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string[]) {
	if (!name.length) return
	emit('go-to-risks', name, [])
}
</script>

<template>
	<table v-if="model?.length" class="w-100" :class="props.class">
		<tr v-for="(y, yIndex) in rows" :key="yIndex">
			<td v-for="(x, xIndex) in cols" :key="xIndex" class="cell" :style="bg(x, y)">
				<div class="square d-flex align-items-center">
					<span
						class="mx-auto text risks-cell"
						v-one-tooltip="{
							content: () => h(RisksTooltip, { risks: model?.[yIndex]?.[xIndex] }),
						}"
						@click="goToRisks(model?.[yIndex]?.[xIndex]?.map((r) => r.name) ?? [])"
					>
						{{ model?.[yIndex]?.[xIndex]?.length ?? '-' }}
					</span>
				</div>
			</td>
		</tr>
	</table>
</template>

<style lang="sass" scoped>
table
  table-layout: fixed

table, tr, td
  border: 0
  margin: 0
  padding: 0

.square
  position: absolute
  inset: 0
  border: 2px solid white
  border-radius: 0.5rem
  overflow: hidden

.cell
  border-radius: 0.5rem
  overflow: hidden
  position: relative

.text
  color: white
  text-shadow: 1px 1px 1px black
</style>
